const messages = {

    "products": [
        "Produkty",
        "Produkty",
    ],

    "audit_result_info": [
        "Při kontrole sortimentu jsme prověřili celkově {total} produktů, z kterých je na Heurece {paired} spárovaných. Ty jsou nejčastěji na {most_position}. pozici produktové karty, přičemž průměrně soutěží s {avg_offers} konkurenčními nabídkami. Sortiment jsme rozdělili do čtyř kategorií podle toho, jak v auditu obstál.",
        "Pri kontrole sortimentu sme preverili celkovo {total} produktov, z ktorých je na Heureke {paired} spárovaných. Tie sú najčastejšie na {most_position}. pozícii produktovej karty, pričom priemerne súťažia s {avg_offers} konkurenčnými ponukami. Sortiment sme rozdelili do štyroch kategórií podľa toho, ako v audite obstál.",
    ],

    "audit_result_paired_hint": [
        "* V kontrolách auditu jsou zahrnuté pouze spárované produkty.",
        "* V kontrolách auditu sú zahrnuté iba spárované produkty.",
    ],

    "audit_result_footer": [
        "Rádi byste vyřešili nalezené problémy a díky upozornění či doporučení dosáhli se svou inzercí na ty nejlepší? Vyzkoušejte aplikaci pro automatický bidding Bidding Fox. Její zkušební doba je 30 dní a určitě se z nástroje stane váš užitečný pomocník. Nechte Lišáka pracovat za vás. Tým Bidding Fox",
        "Radi by ste vyriešili nájdené problémy a vďaka upozorneniam či odporúčaniam dosiahli so svojou inzerciou na tie najvyššie priečky? Vyskúšajte biddingový automat Bidding Fox. Vyskúšajte si ho na 30 dní zdarma a určite sa z nástroja stane váš užitočný pomocník. Nechajte Lišiaka pracovať za vás. Tým Bidding Fox.",
    ],

    "bidding_group_ok": [
        "V pořádku",
        "V poriadku",
    ],
    "bidding_group_ok_info": [
        "U {bidding_group_ok} produktů jsme nenašli žádný problém a jsou v inzerci plně konkurenceschopné. Níže na stránce si můžete prohlédnout graf s rozložením cen či přímo výpis zahrnutých nabídek. Každou z nich si také lze otevřít na Heurece a nebo na e-shopu.",
        "U {bidding_group_ok} produktov sme nenašli žiadny problém a sú v inzercii naplno schopné konkurencie. Nižšie na stránke si môžete prehliadnuť graf s rozložením cien či výpis zahrnutých ponúk. Každú z nich je tiež možné overiť na Heureke alebo v e-shope.",
    ],
    "bidding_group_problems": [
        "S problémem",
        "S problémom",
    ],
    "bidding_group_problems_info": [
        "Během kontroly jsme našli {bidding_group_problems} produktů, které nevyužívají svůj potenciál naplno a vyskytl se u nich některý z problémů. O kousek níže máte k dispozici výpis jednotlivých detekcí, graf rozložení pozic a seznam zahrnutých nabídek.",
        "V priebehu kontroly sme našli {bidding_group_problems} produktov, ktoré nevyužívajú svoj potenciál naplno a vyskytol sa u nich nejaký problém. O kúsok nižšie máte k dispozícii výpis jednotlivých detekcií, graf rozloženia pozícií a zoznam zahrnutých ponúk.",
    ],
    "bidding_group_warnings": [
        "S upozorněním",
        "S upozornením",
    ],
    "bidding_group_warnings_info": [
        "Možné nedostatky jsme nalezli u {bidding_group_warnings} produktů. Zkontrolujte si nabídky zahrnuté v rozepsaných upozorněních níže na stránce. Lepší přehled si udržíte i pomocí grafu rozložení pozic nebo výpisu nalezených produktů.",
        "Možné nedostatky sme našli u {bidding_group_warnings} produktov. Skontrolujte si ponuky zahrnuté v rozpísaných upozorneniach nižšie na stránke. Lepší prehľad si udržíte aj pomocou grafu rozloženia pozícií alebo výpisu nájdených produktov.",
    ],
    "bidding_group_recommendations": [
        "S doporučením",
        "S odporúčaním",
    ],
    "bidding_group_recommendations_info": [
        "Pár drobností stačí dotáhnout u {bidding_group_recommendations} produktů, aby byly plně konkurenceschopné. Doporučení vám pomohou doladit poslední detaily, které zvýší vaše šance na obsazení nejlepších pozic. Na stránce nechybí ani graf rozložení sortimentu na biddingových pozicích či mimo něj, seznam detekcí a zahrnutý sortiment.",
        "Pár drobností stačí dotiahnuť u {bidding_group_recommendations} produktov, aby boli plne konkurencieschopné. Odporúčania vám pomôžu doladiť posledné detaily, ktoré zvýšia vaše šance na obsadenie najlepších pozícií. Na stránke nechýbajú ani graf rozloženie sortimentu na biddingových pozíciách alebo mimo nej, zoznam detekciou a zahrnutý sortiment.",
    ],

    "not_paired": [
        "Nespárované produkty",
        "Nespárované produkty",
    ],
    "not_paired_info": [
        "Produkty jsou nespárované, protože jim chybí a nebo nemají správně vyplněné parametry podle požadavků Heureky. O tom, jak si s párováním poradit, se dočtete na <a href=\"https://blog.heureka.cz/2021/03/04/jak-na-parovani-na-heurece-povinne-parametry/\" target=\"_blank\">jejich blogu</a>.",
        "Produkty sú nespárované, pretože im chýba alebo nemajú správne vyplnené parametre podľa požiadaviek Heureky. O tom, ako si s párovaním poradiť, sa dočítate na <a href=\"https://blog.heureka.cz/2021/03/04/jak-na-parovani-na-heurece-povinne-parametry/\" target=\"_blank\">ich blogu</a>.",
    ],

    "no_heureka_cpc": [
        "Absence elementu HEUREKA_CPC ve feedu",
        "Absencia elementu HEUREKA_CPC vo feede",
    ],
    "no_heureka_cpc_info": [
        "Element HEUREKA_CPC ve feedu je nevyhnutelnou součástí biddingu, jelikož je nositelem informace o nastavené maximální ceně za proklik.",
        "Element HEUREKA_CPC vo feede je nevyhnutnou súčasťou biddingu, nakoľko je nositeľom informácie o nastavenej maximálnej cene za preklik.",
    ],
    
    "zero_heureka_cpc": [
        "Nulová hodnota v elementu HEUREKA_CPC",
        "Nulová hodnota v elemente HEUREKA_CPC ",
    ],
    "zero_heureka_cpc_info": [
        "Specifikace Heureky nedovoluje uvádět v elementu HEUREKA_CPC nulové hodnoty. Navíc se může stát, že i přes vyplněnou 0 vám bude strhávána hodnota kategorie nastavená v administraci Heureky. Zamyslete se tedy, zda by nebylo lepší výšku CPC uvádět, popřípadě ji vůbec nevyplňovat.",
        "Špecifikácie Heuréky nedovoľuje uvádzať v elemente HEUREKA_CPC nulovú hodnotu. Navyše sa môže stať, že aj napriek vyplnenej 0 vám bude strhávaná hodnota kategórie nastavená v administrácii Heuréky. Zamyslite sa teda, či by nebolo lepšie výšku CPC doplniť, prípadne ju vôbec nevypĺňať.",
    ],

    "no_delivery_date": [
        "Chybí dodací doba",
        "Chýba dodacia doba",
    ],
    "no_delivery_date_info": [
        "Informace v elementu <a href=\"https://sluzby.heureka.cz/napoveda/xml-feed/#DELIVERY_DATE\" target=\"_blank\">DELIVERY_DATE</a> je jedním z faktorů rozhodujících o pozici produktu v biddingovém boxu. Pokud dodací lhůtu nedoplníte a bude chybět, hrozí, že se nabídka nedostane mezi doporučené na produktové kartě.",
        "Informácia v elementě <a href=\"https://sluzby.heureka.sk/napoveda/xml-feed/#DELIVERY_DATE\" target=\"_blank\">DELIVERY_DATE</a> je jedným z faktorov rozhodujúcich o pozícii produktu v biddingovom boxe. Ak dodaciu lehotu nedoplníte a bude chýbať, hrozí, že sa ponuka nedostane medzi odporúčané na produktovej karte.",
    ],
    "single_shop": [
        "Produkt je sám v produktové kartě",
        "Produkt je sám v produktovej karte",
    ],
    "single_shop_info": [
        "Jestli víte o několika konkurentech s podobnou nabídkou, existuje pravděpodobnost, že je produkt spárovaný do nesprávné karty na Heurece. Doporučujeme zkontrolovat správnost elementů PRODUCTNAME a CATEGORYTEXT <a href=\"https://sluzby.heureka.cz/napoveda/xml-feed/\" target=\"_blank\">podle požadavků Heureky</a> a nebo kontaktovat zákaznickou podporu Heureky. Nemusí se však jednat o problém v případě, že nabízíte specifický sortiment.",
        "Ak viete o niekoľkých konkurentoch s podobnou ponukou, existuje pravdepodobnosť, že je produkt spárovaný do nesprávnej karty na Heureke. Odporúčame skontrolovať správnosť elementov PRODUCTNAME a CATEGORYTEXT <a href=\"https://sluzby.heureka.sk/napoveda/xml-feed/\" target=\"_blank\">podľa požiadaviek Heureky</a>, alebo kontaktovať zákaznícku podporu Heureky. Nemusí sa však jednať o problém v prípade, že ponúkate špecifický sortiment.",
    ],

    "ppc_off": [
        "V kartě nejsou doporučené nabídky",
        "V karte nie sú odporúčané ponuky",
    ],
    "ppc_off_info": [
        "Pro spuštění biddingu na Heurece jsou potřeba alespoň 2 nabídky v produktové kartě. Pokud je podmínka splněna a bidding není aktivní, nastavte CPC mírně nad minimální cenu kategorie. V případě, že se ani potom nespustí, informujte podporu Heureky.",
        "Pre spustenie biddingu na Heureke sú potrebné aspoň 2 ponuky v produktovej karte. Ak je podmienka splnená a bidding nie je aktívny, nastavte CPC mierne nad minimálnu cenu kategórie. V prípade, že sa ani potom nespustí, informujte podporu Heureky.",
    ],
    "few_shops": [
        "Produkt nabízí málo e-shopů",
        "Produkt ponúka málo e-shopov",
    ],
    "few_shops_info": [
        "Jste zvyklí na vysoce konkurenční prostředí a víte, že stejný produkt nabízí více e-shopů? V tom případě prověřte, zda není sortiment zařazený do nesprávných či duplicitních produktových karet.",
        "Ste zvyknutí na vysoko konkurenčné prostredie a viete, že rovnaký produkt ponúka viac e-shopov? V tom prípade preverte, či tieto produkty nie sú zaradené v nesprávnych alebo duplicitných produktových kartách.",
    ],
    "cpc_lower_than_min_cpc": [
        "Cena za proklik je nižší než minimum kategorie",
        "Cena za kliknutie je nižšia ako minimum kategórie",
    ],
    "cpc_lower_than_min_cpc_info": [
        "V případě, že nastavujete nižší cenu za proklik než je minimum kategorie, bude vám Heureka přesto strhávat jimi udávanou nejnižší sazbu CPC v dané kategorii. Pokud nechcete nebo si nemůžete dovolit vyšší cenu za proklik, je lepší ji neposílat. V opačném případě hodnotu zvyšte na požadované minimum kategorie na Heurece.",
        "V prípade, že nastavujete nižšiu cenu za kliknutie než je minimum kategórie, bude vám Heureka napriek tomu strhávať nimi udávanú najnižšiu sadzbu CPC v danej kategórii. Ak nechcete alebo si nemôžete dovoliť vyššiu cenu za kliknutie, je lepšie ju neposielať. V opačnom prípade hodnotu zvýšte na požadované minimum kategórie na Heureke.",
    ],
    "clicks_without_orders": [
        "Žádané nabídky bez objednavek",
        "Žiadané ponuky bez objednávok",
    ],
    "clicks_without_orders_info": [
        "Produkty s vysokým počtem prokliků, ale žádnými konverzemi. <a href=\"https://www.bidding-fox.cz/nejcastejsi-priklady-nespravneho-sparovani\" target=\"_blank\">Zkontrolujte jejich zařazení do produktových karet</a> a nákupní proces. Je možné, že jeden z kroků brání zákazníkovi v dokončení objednávky.",
        "Produkty s vysokým počtom preklikov, no žiadnymi konverziami. <a href=\"https://www.bidding-fox.sk/najcastejsie-priklady-nespravneho-sparovania\" target=\"_blank\">Skontrolujte ich zaradenie do produktových kariet</a> a nákupný proces. Je možné, že jeden z krokov bráni zákazníkovi v dokončení objednávky.",
    ],
    "different_cpc_in_conversions": [
        "Průměrné CPC z reportu konverzí je vyšší než HEUREKA_CPC",
        "Priemerné CPC z reportu konverzií je vyššie ako HEUREKA_CPC",
    ],
    "different_cpc_in_conversions_info": [
        "Nejčastějším důvodem může být biddování přímo v administraci Heureky. Projděte si report konverzí nebo detail detekce a zjistěte, zda nedošlo k vychýlení hodnot či jinému nedopatření.",
        "Najčastejším dôvodom môže byť biddovanie priamo v administrácii Heuréky. Prejdite si report konverzií alebo detail detekcie a zistite, či nedošlo k vychýleniu hodnôt či inému nedopatreniu.",
    ],

    "bidding_enabled_without_me": [
        "Produkty nedosahují biddingových pozic",
        "Produkty nedosahujú biddingových pozícií",
    ],
    "bidding_enabled_without_me_info": [
        "Na produktových kartách je spuštěný bidding, vaše produkty se však nedostaly mezi doporučené. Je možné, že nastavená výška maximálního CPC je nedostatečná.",
        "Na produktových kartách je spustený bidding, vaše produkty sa však nedostali medzi odporúčané. Je možné, že nastavená výška max. CPC je nedostatočná.",
    ],

    "top_product_not_in_bidding": [
        "TOP produkt kategorie není v biddingovém boxu",
        "TOP produkt kategórie nie je v biddingovém boxe",
    ],
    "top_product_not_in_bidding_info": [
        "Vaše nabídka je na Heurece zařazena mezi TOP produkty kategorie, ale v produktové kartě není mezi doporučenými nabídkami. Vydejte se cestou biddingu, abyste dosáhli na konkurenční e-shopy. A pokud již biddujete, zkuste zvýšit cenu za proklik.",
        "Vaša ponuka je na Heureke zaradená medzi TOP produktami kategórie, ale v produktovej karte nie je medzi odporúčanými ponukami. Vydajte sa cestou biddingu, aby ste dosiahli na konkurenčné e-shopy. A ak už biddujete, skúste zvýšiť cenu za preklik.",
    ],
    "too_expensive_for_bidding": [
        "Vaše cena je o 20 % vyšší než nejdražší produkt v biddingu",
        "Vaša cena je o 20% vyššia ako najdrahší produkt v biddingu",
    ],
    "too_expensive_for_bidding_info": [
        "Jedná se o příliš drahé produkty. Zkuste cenu snížit, v opačném případě se může stát, že vás Heureka, ani přes vysoké CPC, nezařadí mezi doporučené nabídky.",
        "Ide o príliš drahé produkty. Skúste cenu znížiť, v opačnom prípade sa môže stať, že vás Heureka ani vďaka vysokému CPC nezaradí medzi odporúčané ponuky.",
    ],
    "in_bidding_without_clicks": [
        "V biddingovém boxu bez prokliku",
        "V biddingovom boxe bez prekliku",
    ],
    "in_bidding_without_clicks_info": [
        "Je možné, že se nacházíte v příliš konkurenčním prostředí. Zamyslete se nad tím, jak být na tom lépe než ostatní e-shopy. Pomoci by vám mohla nabídka dárku ke každé objednávce a nebo zlevnění ceny za dopravu.",
        "Je možné, že sa nachádzate v príliš konkurenčnom prostredí. Zamyslite sa nad tým, ako byť na tom lepšie ako ostatné e-shopy. Pomôcť by vám mohla ponuka darčeka ku každej objednávke a alebo zlacnenie ceny za dopravu.",
    ],
    "cpc_50_percent_of_price": [
        "CPC vyšší než 50 % ceny produkty",
        "CPC vyššie než 50 % ceny produktu",
    ],
    "cpc_50_percent_of_price_info": [
        "Cena za proklik je u těchto produktů vysoká a může způsobovat zbytečně vysoké náklady. U produktů prověřte jakých výsledků dosahují a zda je prostor na snížení CPC.",
        "Cena za preklik je u týchto produktov vysoká a môže spôsobovať zbytočne vysoké náklady. Pri produktoch preverte akých výsledkov dosahujú a či je priestor na zníženie CPC.",
    ],
    "too_high_availability_for_bidding": [
        "Produkty s příliš dlouhou dostupností",
        "Produkty s príliš dlhou dostupnosťou",
    ],
    "too_high_availability_for_bidding_info": [
        "Nenaskladněné zboží může mít horší pozici v biddingu a nebo se do něj vůbec nedostane. Podívejte se, zda máte dostupnost správně vyplněnou a nebo zda není možné produkty naskladnit dříve.",
        "Nenaskladněný tovar môže mať horšie pozíciu v biddingu, alebo sa do neho vôbec nedostane. Pozrite sa, či máte dostupnosť správne vyplnenú, alebo či nie je možné produkty naskladniť skôr.",
    ],
    "in_bidding_and_top_cart": [
        "Produkty v biddingu a zároveň na TOP pozici s košíkem",
        "Produkty v biddingu a súčasne na TOP pozícii s košíkom",
    ],
    "in_bidding_and_top_cart_info": [
        "Produkty nacházející se na TOP pozici s košíkem jsou pro zákazníka dostatečně viditelné. Přehodnoťte nutnost zařazení nabídky i v biddingovém boxu. Můžete tak ušetřit nemalé náklady.",
        "Produkty nachádzajúce sa na TOP pozíciu s košíkom sú pre zákazníka dostatočne viditeľné. Prehodnoťte nutnosť zaradenia ponuky aj v biddingovom boxe. Môžete tak ušetriť nemalé náklady.",
    ],
    "more_than_5_position": [
        "Produkty na vyšší než 5. pozici v řazení podle ceny",
        "Produkty na vyššej ako 5. pozícii v radení podľa ceny",
    ],
    "more_than_5_position_info": [
        "K nabídce, jenž se nachází na vyšší než 5. pozici v produktové kartě, se už zákazník nemusí dostat. Využijte bidding a zviditelněte ji, popřípadě zvažte snížení ceny pro obsazení lepší pozice.",
        "K ponuke, ktorá sa nachádza na vyššej ako 5. pozícii v produktovej karte, sa už zákazník nemusí dostať. Využite bidding a zviditeľnite ju, prípadne zvážte zníženie ceny pre obsadenie lepšej pozície.",
    ],
    "first_and_too_cheap_wrong_paired": [
        "Produkty za příliš nízkou cenu",
        "Produkty za príliš nízku cenu",
    ],
    "first_and_too_cheap_wrong_paired_info": [
        "Váš sortiment je výrazně levnější než další nabídky na produktové kartě. Může se jednat o špatné spárování, proto doporučujeme pozornou kontrolu.",
        "Váš sortiment je výrazne lacnejší ako ďalšie ponuky na produktovej karte. Môže sa jednať o zlé spárovanie, preto odporúčame pozornú kontrolu.",
    ],
    "edgy_delivery": [
        "Zboží se zlomovou dostupností",
        "Tovar so zlomovou dostupnosťou",
    ],
    "edgy_delivery_info": [
        "Tyto produkty mají nastavené datum dodání, které by mohlo spadat do <a href=\"https://www.bidding-fox.cz/lisacka-doporuceni-bidding\" target=\"_blank\">nižší kategorie na srovnávači</a>. Doporučujeme přehodnotit nastavenou dostupnost produktu. Drobnou úpravou můžete dosáhnout lepšího výkonu inzerce.",
        "Tieto produkty majú nastavený dátum dodania, ktorý by mohol spadať do <a href=\"https://www.bidding-fox.sk/lisiacke-odporucania-pre-bidding\" target=\"_blank\">nižšej kategórie na porovnávači</a>. Odporúčame prehodnotiť nastavenú dostupnosť produktu. Menšou úpravou môžete dosiahnuť lepšieho výkonu inzercie.",
    ],
    "high_pno": [
        "Sortiment s vysokým PNO",
        "Sortiment s vysokým PNO",
    ],
    "high_pno_info": [
        "Tyto produkty mají PNO nad 30%. Důvodem může být příliš vysoká cena za proklik, ale také konkurenční boj v produktové kartě. Ověřte si, zda výše CPC odpovídá vašim požadavkům a nebo zvažte nasazení biddingového automatu, který vám bude nastavené limity hlídat.",
        "Tieto produkty majú PNO nad 30%. Dôvodom môže byť príliš vysoká cena za kliknutie, ale aj konkurenčný boj v produktovej karte. Overte si, či výška CPC zodpovedá vašim požiadavkám a alebo zvážte nasadenie biddingového automatu, ktorý vám bude nastavené limity strážiť.",
    ],
}

module.exports.phrases = {
    locale: ["cs-CZ","sk-SK"],
    messages,
}
